<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-md-6 col-sm-4 pb-0 mb-0">
        <table>
          <td  style="vertical-align: middle;"><img src="assets/img/global/receita.png" alt="pesquisa" title="" width="32" height="32"></td>
          <td>
            <p
              [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
              {{titulo}}</p>
            <p
              [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
              EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
          </td>
        </table>
      </div>
      <div class="col-md-6 col-sm-8 pb-0 mb-0">
        <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1' : 'linha-normal mt-1'" />
    <div class="form-row">
      <div class="col-sm-0 col-md-0 col-lg-0 col-xl-0 mt-1">
        Período:
      </div>
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <p-calendar id="data1" [(ngModel)]="data1" (onSelect)="onSelectPeriodo()" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="col-sm-0 col-md-0 col-lg-0 col-xl-0 mt-1 text-center "><span>à</span></div>
      <div class="form-group col-sm-4 col-md-3 col-lg-2 col-xl-2">
        <p-calendar id="data2" [(ngModel)]="data2" (onSelect)="onSelectPeriodo()" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="offset-sm-0 offset-md-0 offset-lg-1 offset-xl-2 col-sm-12 col-md-4 col-lg-5 col-xl-5 mr-0 pr-0">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista.length > 0">
      <div class="col-md">
        <div class="table-responsive">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-center ">
                  <a href="javascript:;" (click)="ordenar(1)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 1"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>DATA
                  </a>
                </th>
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(2)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 2"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>DESCRIÇÃO DA RECEITA
                  </a>
                </th>
                <th scope="col">
                  <a href="javascript:;" (click)="ordenar(3)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 3"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>CONTA BANCÁRIA
                  </a>
                </th>
                <th scope="col" class="text-right">
                  <a href="javascript:;" (click)="ordenar(4)"
                    [ngClass]="login.contraste ? 'text-white fonte-acessibilidade' : 'text-black-50 fonte-acessibilidade'">
                    <span *ngIf="col === 4"><img src="assets/img/global/{{imagem}}" alt="localizar" height="16"
                        width="16">&nbsp;</span>VALOR RECEBIDO
                  </a>
                </th>
                <th scope="col" style="width: 90px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">{{item.data_recebimento | date:'dd/MM/yyyy':'GMT'}}</td>
                <td>
                  {{item.ficha.receita.codigo}} {{item.ficha.receita.nome}}
                  <span *ngIf="!item.ficha.restituicao && !item.ficha.redutor && item.valor_recebido < 0"
                    class="badge badge-danger">ANULAÇÃO</span>
                  <span *ngIf="item.ficha.redutor && item.valor_recebido < 0" class="badge badge-warning">REDUTOR</span>
                  <span *ngIf="item.ficha.restituicao && item.valor_recebido < 0"
                    class="badge badge-info">RESTITUIÇÃO</span>
                </td>
                <td style="width: 15%">{{item.conta.agencia}} {{item.conta.numero_conta}} {{item.conta.banco.nome}}</td>
                <td class="text-right">{{item.valor_recebido | number:'1.2-2'}}</td>
                <td class="text-right" style="min-width: 90px;">
                  <button (click)="editar(item.id)" class="btn btn-sm btn-outline-secondary mr-2 fonte-acessibilidade">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row fonte-acessibilidade float-right" *ngIf="lista.length > 0">
      <div class="col-12">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
    <div class="row" *ngIf="lista.length === 0">
      <div class="col-12 mt-5 ml-3">
        <img src="assets/img/global/warning.png" alt="atencao" class="mb-1 ">
        <br />
        <span
          [ngClass]="this.login.contraste ? 'text-white font-weight-bold ml-1' : 'text-black-50 font-weight-bold ml-1'">NÃO
          HÁ LANÇAMENTOS EFETUADOS! </span>
      </div>
    </div>
    <div class="row fonte-acessibilidade" *ngIf="especie === 'covid'">
      <div class="col-sm-12 col-md-4 col-lg-4">
        <div class="card border-danger ">
          <div class="card-body">
            <h6 class="card-title">
              <img src="assets/img/global/manage_sources.png" alt="" width="24" height="24" class="mr-1 float-left">
              <button class="btn btn-link text-danger" (click)="despesaCovid()">
                Despesas realizadas
              </button>
            </h6>
            <p class="text-black-50 pl-4" style="font-size: 11px;">
              Informação das despesas realizadas em ações de combate à pandemia.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
